import { render, staticRenderFns } from "./checkPhoneAuth.vue?vue&type=template&id=45c578ee"
import script from "./checkPhoneAuth.vue?vue&type=script&lang=js"
export * from "./checkPhoneAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports